import { useState, useEffect } from "react";
import { GET_TESTIMONIALS } from '../api/constants'

export const useTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(GET_TESTIMONIALS);
        const data = await response.json();

        if (data.status) {
          setTestimonials(data.data || []);
        } else {
          setTestimonials([]);
          setError(data.message || "Failed to fetch testimonials");
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
        setError("Failed to fetch testimonials");
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  return { testimonials, loading, error };
};
